var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgInfoCircle = function SvgInfoCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 8.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM10.5 12h.75v5.25c0 .414.336.75.75.75h1.5a.75.75 0 0 0 0-1.5h-.75v-5.25a.75.75 0 0 0-.75-.75h-1.5a.75.75 0 0 0 0 1.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22.5c5.799 0 10.5-4.701 10.5-10.5S17.799 1.5 12 1.5 1.5 6.201 1.5 12 6.201 22.5 12 22.5Zm0-1.5a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z"
  })));
};

export default SvgInfoCircle;